/* eslint-disable */
import React, { useEffect } from "react";

import RaindropCircle from "../../../ui-components/raindrop-circle/raindrop-circle.tsx";

import { motion } from "framer-motion";

enum MeditationState {
  IDLE = "IDLE",
  BREATH_IN = "BREATH_IN",
  HOLD_IN = "HOLD_IN",
  BREATH_OUT = "BREATH_OUT",
  HOLD_OUT = "HOLD_OUT",
}

const RaindropMeditation = ({ values }) => {
  const [scale, setScale] = React.useState(1);
  const [meditationState, setMeditationState] = React.useState<MeditationState>(
    MeditationState.HOLD_OUT
  );

  const holdSeconds = 4;

  const onStart = () => {
    switch (meditationState) {
      case MeditationState.IDLE:
        setMeditationState(MeditationState.BREATH_IN);
        break;
      case MeditationState.BREATH_IN:
        setMeditationState(MeditationState.HOLD_IN);
        break;
      case MeditationState.HOLD_IN:
        setMeditationState(MeditationState.BREATH_OUT);
        break;
      case MeditationState.BREATH_OUT:
        setMeditationState(MeditationState.HOLD_OUT);
        break;
      case MeditationState.HOLD_OUT:
        setMeditationState(MeditationState.BREATH_IN);
        break;
    }
  };

  useEffect(() => {
    switch (meditationState) {
      case MeditationState.BREATH_IN:
        setScale(1.5);
        break;
      case MeditationState.HOLD_IN:
        setScale(1.5);
        break;
      case MeditationState.BREATH_OUT:
        setScale(1);
        break;
      case MeditationState.HOLD_OUT:
        setScale(1);
        break;
    }
  }, [meditationState]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      onStart();
    }, holdSeconds * 1000);

    return () => clearInterval(intervalId);
  }, [meditationState]);

  const text = {
    [MeditationState.IDLE]: "Begin",
    [MeditationState.BREATH_IN]: "breath in",
    [MeditationState.HOLD_IN]: "hold your breath",
    [MeditationState.BREATH_OUT]: "breath out",
    [MeditationState.HOLD_OUT]: "hold your breath",
  }[meditationState];

  return (
    <div
      id={"raindrop-search"}
      className={
        "flex flex-col justify-center  w-full h-full items-center relative"
      }
    >
      <div className="flex flex-col h-full pt-12 absolute">
        <h1 className="text-lg opacity-30">{text}</h1>
      </div>

      <motion.div
        animate={{ scale: scale }} // Scale to 1.5 times its original size
        transition={{ duration: holdSeconds }} // Duration of the animation
      >
        <RaindropCircle
          sausageValues={values}
          animate={{ scale: 1 }}
          size={"SMALL"}
          isRaindropPlus={true}
          isPaused={false}
        />
      </motion.div>
    </div>
  );
};

export default RaindropMeditation;
